"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationTimeWorkedDto = instanceOfOrientationTimeWorkedDto;
exports.OrientationTimeWorkedDtoFromJSON = OrientationTimeWorkedDtoFromJSON;
exports.OrientationTimeWorkedDtoFromJSONTyped = OrientationTimeWorkedDtoFromJSONTyped;
exports.OrientationTimeWorkedDtoToJSON = OrientationTimeWorkedDtoToJSON;
exports.OrientationTimeWorkedDtoToJSONTyped = OrientationTimeWorkedDtoToJSONTyped;
const OrientationSessionTimeWorkedDto_1 = require("./OrientationSessionTimeWorkedDto");
/**
 * Check if a given object implements the OrientationTimeWorkedDto interface.
 */
function instanceOfOrientationTimeWorkedDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    return true;
}
function OrientationTimeWorkedDtoFromJSON(json) {
    return OrientationTimeWorkedDtoFromJSONTyped(json, false);
}
function OrientationTimeWorkedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionTimeWorkedDto_1.OrientationSessionTimeWorkedDtoFromJSON)),
    };
}
function OrientationTimeWorkedDtoToJSON(json) {
    return OrientationTimeWorkedDtoToJSONTyped(json, false);
}
function OrientationTimeWorkedDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionTimeWorkedDto_1.OrientationSessionTimeWorkedDtoToJSON)),
    };
}
//# sourceMappingURL=OrientationTimeWorkedDto.js.map